/** Saved comparison runs, newest first. */

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

interface RunSummary {
  runId: string; createdAt: string; label?: string;
  pageNumber?: number; userName?: string;
}

export default function Runs() {
  const [runs, setRuns] = useState<RunSummary[] | null>(null);

  const load = () => api.get("/api/ocrlab/runs").then((d) => setRuns(d.runs));
  useEffect(() => { load(); }, []);

  return (
    <div className="mx-auto max-w-3xl px-6 py-10">
      <header className="mb-6">
        <h1 className="text-xl font-semibold text-fh-text-title">Saved runs</h1>
        <p className="mt-1 text-fh-body text-fh-text-secondary">
          Kept only when you press Save; expire after 90 days.
        </p>
      </header>

      {!runs && <p className="text-fh-body text-fh-text-muted">Loading…</p>}
      {runs?.length === 0 && (
        <p className="text-fh-body text-fh-text-muted">
          No saved runs yet. Runs are kept only when you press Save, and expire after 90 days.
        </p>
      )}

      <ul className="space-y-2">
        {runs?.map((r) => (
          <li key={r.runId} className="flex items-center justify-between rounded-lg bg-white p-4 ring-1 ring-fh-border-soft">
            <Link to={`/ocrlab?run=${r.runId}`} className="min-w-0 flex-1">
              <p className="truncate text-fh-body font-medium text-fh-text-strong hover:underline">
                {r.label || "(unlabelled)"}
              </p>
              <p className="mt-0.5 text-fh-meta text-fh-text-muted">
                {new Date(r.createdAt).toLocaleString()}
                {r.pageNumber ? ` · page ${r.pageNumber}` : ""}
                {r.userName ? ` · ${r.userName}` : ""}
              </p>
            </Link>
            <button
              onClick={() => api.del(`/api/ocrlab/runs/${r.runId}`).then(load)}
              className="shrink-0 text-fh-meta text-fh-text-muted hover:text-fh-danger"
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
